<!--  -->
<template>
  <div :class="['newdrawLots', { inApp: $root.$data.isApp }]">
    <common-title
      titleName="抽签活动"
      :bcColor="'#fff'"
      :zIndex="1000"
    >
    </common-title>
    <section class="section">
      <div class="drawWarrp">
        <img
          class="chou"
          :src="imgUrls[0]"
          alt=""
          @click="drawBtn"
        >
      </div>

    </section>

  </div>
</template>

<script>
import { mapState } from 'vuex';
import { getRegisterSourceInfo } from '@/utils/tools';

export default {
  components: {
  },
  data() {
    return {
      imgUrls: [
        `${this.$global.OSS_IMAGE_PREFIX}/ark-student-wap/fondOfLearningDraw/%E6%8C%89%E9%92%AE%402x.png`,
      ],
      showShare: false,
      loading: true,
      shakeBtn: false,
    };
  },
  computed: {
    ...mapState(['userInfo']),
  },
  watch: {},
  methods: {
    // 抽奖按钮
    drawBtn() {
      if (!this.userInfo.id) {
        const { isApp = false } = this.$root.$data;
        if (isApp) {
          getRegisterSourceInfo(this, 'drawLots', 2, false);
        } else {
          const { search } = window.location;
          // has=false =>search没有拼参数
          const has = search !== '';
          const param = { has, redirect: '/drawLots', ...this.$route.query };
          this.$router.push({ path: '/registrationLogin', query: param });
        }
      } else {
        this.shakeBtn = true;
        const drawNum = Math.floor(Math.random() * 8);
        setTimeout(() => {
          this.shakeBtn = false;
          this.$router.push({
            path: '/drawResult',
            query: {
              drawNum,
            },
          });
        }, 1000);
      }
    },

    getLogin(APPSESSION) {
      const ua = navigator.userAgent.toLowerCase();
      const cookieToken = /ohos/.test(ua) ? APPSESSION.token : APPSESSION;
      if ((window?.navigator?.userAgent || '').includes('iqihang')) {
        window.localStorage.setItem('accessToken', cookieToken || '');
        this.getLoginAfter();
      }
    },
    async getLoginAfter() {
      await this.$root.getUserInfo();
    },

  },
  created() {
  },
  mounted() {
    window['iqhApp2jsBridge.triggerSC'] = {};
    setTimeout(() => {
      // 获取登录状态
      window['iqhApp2jsBridge.triggerSC'].getLogin = this.getLogin;
    }, 100);
  },
};
</script>
<style lang="scss" scoped>
.newdrawLots {
  box-sizing: border-box;
  width: 100%;
  height: 100vh;
  padding-top: 100px;
  background: #F7986A;
  &.inApp {
    padding-top: 0;
  }
  .section {
    position: relative;
    width: 100%;
    height: 1158px;
    background: url(https://iqh-zt-pord-cdn.iqihang.com/ark-student-wap/fondOfLearningDraw/%E8%83%8C%E6%99%AF%402x.png) no-repeat;
    background-size: 100% 100%;
    .chou {
      position: absolute;
      top: 869px;
      left: 320px;
      width: 111px;
      height: 111px;
      animation: breatheEffect 3s ease-in-out infinite;
    }
  }
  .share-btn {
    position: fixed;
    right: 36px;
    bottom: 20px;
    left: 36px;
    width: 678px;
    margin: 0 auto;
    color: #fff;
    font-weight: 500;
    font-size: 29px;
    line-height: 80px;
    background: #ff7f41;
    border-radius: 45px;
  }

  @keyframes breatheEffect {
    0% {
      transform: scale(1);
    }

    25% {
      transform: scale(1.05);
    }

    50% {
      transform: scale(1);
    }

    75% {
      transform: scale(1.05);
    }
  }
}
</style>
